import React from "react";
import { TextField, MenuItem, Typography, Box } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

function SelectField({
  name,
  placeholder,
  size,
  value,
  options,
  onChange,
  state,
  disable,
  required,
  sx,
}) {
  console.log(state?.errorFields[name], "state?.errorStatus[name]");
  return (
    <>
      <Box sx={{ display: "flex" }}>
        <TextField
          autoFocus={name == "gstcategory"}
          error={state?.errorStatus[name] === true ? true : false}
          select
          value={value}
          id={name}
          name={name}
          disabled={disable}
          label={placeholder}
          variant="outlined"
          required={required}
          size={size}
          fullWidth
          onChange={onChange}
          InputLabelProps={{
            shrink: value ? true : false,
          }}
          sx={sx}
        >
          {options.length > 0 ? (
            options.map((item, ind) => {
              return (
                <MenuItem key={ind} value={item.value}>
                  {item.option}
                </MenuItem>
              );
            })
          ) : (
            <MenuItem key={"1"} value={"noitem"}>
              {"No Item Found"}
            </MenuItem>
          )}
        </TextField>
        {(name === "country" || name === "states" || name === "district") &&
          value === "" && (
            <Box sx={{ position: "relative" }}>
              {/* <CheckIcon sx={{ color: 'red', margin: "0px 10px 5px 0px",position:"absolute",right:"20px",top:"5px" }} /> */}
            </Box>
          )}
      </Box>
      <Typography
        sx={{
          marginTop: "2px",
          marginLeft: "10px",
          marginBottom: "0px",
          fontSize: "11px",
          color: "danger.main",
        }}
      >
        {state?.errorFields[name]}
      </Typography>
    </>
  );
}

export default SelectField;
